// pathRegexList.js
'use strict';

import { createLangAwareRegExp } from '../resource/langPath.js';

const landingBaseRegExp =
  /^\/(?!settings|404|tos|privacy|error|signup|login|addvalue|join|revenue|standalone|iframe|geo-blocked)/i;
const ageVerifierBaseRegExp =
  /^\/(?!settings|404|tos|privacy|error|login|join|revenue|standalone|iframe|geo-blocked)/i;
const addvalueBaseRegExp = /^\/(?!signup|login|404|geo-blocked)/i;

// regular expression with language prefix
export const landingRegExp = createLangAwareRegExp(landingBaseRegExp);
export const ageVerifierRegExp = createLangAwareRegExp(ageVerifierBaseRegExp);
export const addvalueRegExp = createLangAwareRegExp(addvalueBaseRegExp);

// regular expression for paths that are not age verify
const ageVerifyBaseRegExp = /^\/(?!age-verify)/i;
export const notAgeVerifyRegExp = createLangAwareRegExp(ageVerifyBaseRegExp);
